import AppShell from "@/components/layout/AppShell";
import TableGrid from "@/components/grid/TableGrid";
import useTables from "@/hooks/useTables";
import useAppStateQuery from "@/hooks/useAppState";
import useTimerTick from "@/hooks/useTimerTick";

export default function HomePage() {
  // Phase G (Δ-11) — mounts the single global 1s tick. Must be called
  // unconditionally before any early-return so the tick lives for the
  // entire <HomePage> lifetime.
  useTimerTick();

  const { isLoading: tablesLoading, error: tablesError } = useTables();
  const { isLoading: stateLoading } = useAppStateQuery();

  if (tablesLoading || stateLoading) {
    return (
      <AppShell>
        <div
          data-testid="loading-spinner"
          className="flex items-center justify-center h-64"
        >
          <div className="animate-spin rounded-full h-10 w-10 border-2 border-gray-300 border-t-gray-600" />
        </div>
      </AppShell>
    );
  }

  if (tablesError) {
    return (
      <AppShell>
        <div
          data-testid="error-message"
          className="flex items-center justify-center h-64 text-red-500"
        >
          Failed to load tables. Please try again.
        </div>
      </AppShell>
    );
  }

  return (
    <AppShell>
      <TableGrid />
    </AppShell>
  );
}
